import { Sparkles } from "lucide-react";

export const SponsoredBadge = () => (
  <div
    data-testid="sponsored-badge"
    className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-accent to-orange-400 text-accent-foreground px-2 py-0.5 text-[10px] tracking-wider uppercase font-bold shadow-sm"
  >
    <Sparkles className="h-2.5 w-2.5" fill="currentColor" strokeWidth={2} />
    Sponsored
  </div>
);
